import React from 'react'
import { CuiButton } from 'front-lib'
import { useIsMobile } from 'src/hooks/useIsMobile'
import './HeroSection.scss'

interface HeroSectionProps {
  data: {
    heroTitle?: string
    heroSubtitle?: string
    heroPromoCopy?: string
    ctaLabel?: string
    heroImage?: string
    heroImageMobile?: string
    browserTitle?: string
  }
}

const HeroSection: React.FC<HeroSectionProps> = ({ data }) => {
  const {
    heroTitle,
    heroSubtitle,
    heroPromoCopy,
    ctaLabel,
    heroImage,
    heroImageMobile
  } = data
  const isMobile = useIsMobile()

  // Use mobile image if available and on mobile, otherwise fall back to desktop image
  const imageSrc = isMobile && heroImageMobile ? heroImageMobile : heroImage

  return (
    <section className="hero-section">
      <div className="hero-section__content">
        <h1
          className="hero-section__title"
          dangerouslySetInnerHTML={{ __html: heroTitle || '' }}
        />
        {heroSubtitle && (
          <p className="hero-section__subtitle">{heroSubtitle}</p>
        )}
        {heroPromoCopy && (
          <p className="hero-section__subtitle hero-section__promo">
            {heroPromoCopy}
          </p>
        )}
        <CuiButton onClick={() => {}} size="large">
          {ctaLabel || 'Resubscribe now'}
        </CuiButton>
      </div>
      {imageSrc && (
        <div className="hero-section__image-wrapper">
          <img
            className="hero-section__image"
            src={imageSrc}
            alt="CookUnity chef with new meals"
            loading="eager"
          />
        </div>
      )}
    </section>
  )
}

export default HeroSection
